import React from 'react'
import { ErrorStyle } from './../styles'

export default ({children}) => (
  <p className={`${ErrorStyle} error`}>
    {children}
  </p>
)



// WEBPACK FOOTER //
// ./src/components/Error.js